module.exports = __webpack_public_path__ + "static/media/default-image.9451b251.svg";